export const balanceConstants = {
  heading: `# Check your card balance`,
  subHeading: `#### Please fill in your **Unique Card ID** below to check your card balance.`,
  balanceText: `This can be located on the back of your card. It is alphanumerical and 9-10 digits long`,
  balanceButtonText: `Check Balance`,
  balanceTableHeading: `## Balance`,
  defaultValue: {
    eaid: '',
    last4: ''
  },
  defaultPageSize: 100,
  last4text: `If your card number is '1234 **** **** 5678', enter 5678`,
  validations: {
    eaid: {
      id: 'eaid',
      required: 'Unique Card id is required',
      format: `Unique Card id is invalid`,
    },
    last4: {
      id: 'last4',
      required: 'Last 4 digits of the card number is required',
      format: 'Last 4 digits is invalid',
    }}
};